// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] + "." + {"102":"93f1b65f","133":"57c9fc50","182":"add63587"}[chunkId] + ".chunk.js";
};